<app-layout>
  <app-sidebar sidebar-mob></app-sidebar>

  <div id="desktop-sidemenu-container" sidebar-web class="px-0 col-3 desktop-sidemenu-container d-none d-lg-flex">
    <app-sidebar class="w-100"></app-sidebar>
  </div>
</app-layout>
